<template>
  <div>
    <el-form ref="form1" :model="form" label-width="120px" :inline="true">
      <el-form-item label="出货单号">
        <el-input v-model="form.no" clearable readonly></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDealerList()">搜索</el-button>
        <!-- <el-button type="primary" @click="dealerExport()">导出</el-button> -->
      </el-form-item>
    </el-form>
    <span style="margin: 0 20px">总窜货数量:</span><span style="color: red;">{{feeling_goods_total}}</span>
    <!--表格-->
    <el-table ref="multipleTable" :data="tableData1" v-loading="loading" border stripe style="width: 95%;margin: 20px">
      <el-table-column prop="from_name" label="出货单号" fixed>
      </el-table-column>
      <el-table-column prop="from_name" label="批次号" fixed>
      </el-table-column>
      <el-table-column prop="return_goods_num_total" label="窜货总数量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="" label="操作" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="detail1(scope.row)">明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin: 20px 0" @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="pageNo1" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize1" layout="total, sizes, prev, pager, next, jumper" :total="totalSize1">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { no: "" },
    };
  },
  methods: {
    getList() {},
    handleSizeChange1(val) {
      this.pageSize = val;
      this.pageNo1 = 1;
      this.getList();
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      this.getList();
    },
  },
};
</script>